import React from "react";
import throttle from "lodash.throttle";

import { AppStorage } from "./storage";

export const StorageContext = React.createContext<null | AppStorage>(null);

const self = (s: string): string => s;

export const useStorage = <T>(key: string, fallback: T) => {
    const parse = typeof fallback === "string" ? self : JSON.parse;
    const stringify = typeof fallback === "string" ? self : JSON.stringify;

    const storage = React.useContext(StorageContext);
    if (storage === null) throw Error("storage context not found");

    // get
    const initial: T = React.useMemo(() => {
        const existed = storage.getItem(key);
        if (existed === null) return fallback;
        try {
            return parse(existed);
        } catch (e) {
            return fallback;
        }
    }, [key, fallback, parse]);
    const state = React.useState(initial);

    // set
    const setItem = React.useMemo(() => {
        const fn = storage.setItem.bind(storage);
        return throttle(fn, 2000, { leading: true });
    }, [storage]);
    const [value] = state;
    React.useEffect(() => {
        setItem(key, stringify(value));
    }, [key, value, stringify, setItem]);

    // return
    return state;
};
